/**
 * Constants for EmailBodyEditor component
 */

/**
 * URL that identifies the immutable AI interview invitation link.
 */
export const IMMUTABLE_LINK_URL = "{{ invite_url }}";

/** CSS styles for email wrapper div */
export const EMAIL_WRAPPER_STYLE = "font-family: inherit; text-align: left";

/** Empty email HTML template */
export const EMPTY_EMAIL_HTML = `<div style="${EMAIL_WRAPPER_STYLE}"></div>`;

/** Formats a wildcard name into the display/insertion format */
export const formatWildcard = (name: string): string => `{{ ${name} }}`;

/** Creates regex pattern to match valid wildcard names */
export const createWildcardPattern = (wildcardNames: string[]): string => {
  const escapedNames = wildcardNames.map((name) =>
    name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  );
  return `\\{\\{\\s*(${escapedNames.join("|")})\\s*\\}\\}`;
};

/**
 * Regex to match anchor tags with {{ invite_url }} in href.
 * Used to strip these links from pasted content to prevent duplicate immutable links.
 * Matches both literal {{ invite_url }} and URL-encoded %7B%7B%20invite_url%20%7D%7D variants.
 * Supports both single and double quoted href attributes.
 * Uses 's' (dotall) flag so '.' matches newlines in multi-line anchor tags.
 * Captures the link text content in group 4 for preservation during replacement.
 */
export const INVITE_URL_LINK_REGEX =
  /<a[^>]*href=["'][^"']*(\{\{\s*invite_url\s*\}\}|%7B%7B(%20)?invite_url(%20)?%7D%7D)[^"']*["'][^>]*>(.*?)<\/a>/gis;

/**
 * Creates a fresh copy of a regex to avoid stateful lastIndex issues.
 * Global regexes maintain lastIndex state between exec() calls, which can cause
 * unexpected behavior when reusing the same regex instance.
 */
export const cloneRegex = (regex: RegExp): RegExp =>
  new RegExp(regex.source, regex.flags);
